import { Component, h } from 'preact'
import 'codemirror/mode/css/css'

import Header from '../header'
import Panel from '../panel'
import InputGroup from '../ui-components/InputGroup'
import CodeMirror from '../codemirror/'
import AlertComponent from '../ui-components/AlertComponent'
import {getThirdPartyScriptConfig, updateThirdPartyScriptConfig} from '../../utils/api'

interface Props {}

interface State {
  head: string,
  bodyStart: string,
  bodyEnd: string,
  ssiUrl: string,
  message: 'error' | 'success' | '',
  isLoading?: boolean
}

class ThirdPartyScripts extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      head: '',
      bodyStart: '',
      bodyEnd: '',
      ssiUrl: '',
      message: ''
    }

    this.onSave = this.onSave.bind(this)
  }

  async componentDidMount () {
    this.setState(await getThirdPartyScriptConfig())
  }

  async onSave () {
    this.setState({ message: '', isLoading: true })
    try {
      await updateThirdPartyScriptConfig(this.state)
    } catch (e) {
      console.error(e)
      this.setState({ message: 'error', isLoading: false })
      return
    }
    this.setState({ message: 'success', isLoading: false })
  }

  render (_: Props, { head, bodyStart, ssiUrl, bodyEnd, message, isLoading }: State) {
    const headText = 'Add third-party scripts to the <HEAD> of the community. Adding scripts to the <HEAD> may impact the performance and loading time of your community, don’t add too many scripts here.'
    const bodyStartText = 'Add third-party scripts after opening <BODY> of the community.'
    const bodyEndText = 'Add third-party scripts before the closing </BODY> in the community. Adding scripts here has the least impact on the performance of your community, we recommend to add your scripts here.'

    return (
      <div className='third-party-scripts'>
        <Header
          isLoading={isLoading}
          title='Third-party Scripts'
          saveCallback={this.onSave}
        />
        {
          message !== '' ? (
            <AlertComponent messageType={message} isVisibleFor={3000}/>
          ) : null
        }
        <div class='alert alert-info'>
          <p><strong>Note:</strong> We recommend inviting a professional web developer to work with custom code.
            Insert code at your own risk, and proceed with extreme caution —
            inSided support won’t be able to assist you with custom code issues.
            If you want to test your code before publishing we strongly recommend you to use your staging environment first.</p>
        </div>
        <Panel
          class='third-party-scripts'
          title='Insert in <HEAD>'
        >
          <p>{headText}</p>
          <CodeMirror
            defaultValue={head}
            onChange={(newData) => this.setState({ head: newData })}
            className='customCss__form-textarea'
          />
          <div className='third-party-scripts_ssi-url-wrapper'>
            <InputGroup
              title='SSI URL'
              qaClasses='third-party-scripts_ssi-url'
              type='text'
              onChange={(e : { target: HTMLInputElement }) => this.setState({ ssiUrl: e.target.value })}
              value={ssiUrl} />
          </div>
        </Panel>
        <Panel
          class='third-party-scripts'
          title='After <Body>'
        >
          <p>{bodyStartText}</p>
          <CodeMirror
            defaultValue={bodyStart}
            onChange={(newData) => this.setState({ bodyStart: newData })}
            className='customCss__form-textarea'
          />
        </Panel>
        <Panel
          class='third-party-scripts'
          title='Before </Body>'
        >
          <p>{bodyEndText}</p>
          <CodeMirror
            defaultValue={bodyEnd}
            onChange={(newData) => this.setState({ bodyEnd: newData })}
            className='customCss__form-textarea'
          />
        </Panel>
      </div>
    )
  }
}

export default ThirdPartyScripts
